module.exports = {"222424003":"南山社区工作委员会","222424004":"大明社区工作委员会","222424005":"大川社区工作委员会","222424006":"幸福社区工作委员会","222424007":"新民社区工作委员会","222424008":"新华社区工作委员会","222424009":"东振社区工作委员会","222424010":"江北社区工作委员会","222424100":"汪清镇","222424101":"大兴沟镇","222424102":"天桥岭镇","222424103":"罗子沟镇","222424104":"百草沟镇","222424105":"春阳镇","222424106":"复兴镇","222424107":"东光镇","222424200":"鸡冠乡","222424400":"汪清林业局","222424401":"天桥岭林业局","222424402":"大兴沟林业局","222424404":"八人沟农场","222424407":"罗子沟农场","222424408":"复兴农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222424.json
// module id = 613
// module chunks = 0